import { parseToRgb, readableColor } from "polished";

const FALLBACK_BACKGROUND = "#69b7cb";

export const previewHeaderTheme = (theme) => {
  const candidate = theme?.colors?.[theme.mode === "light" ? "primary_light" : "primary_dark"];
  let background = FALLBACK_BACKGROUND;
  try {
    const parsed = parseToRgb(candidate || FALLBACK_BACKGROUND);
    if (parsed.alpha === undefined || parsed.alpha === 1) background = candidate || FALLBACK_BACKGROUND;
  } catch (_) {
    // Invalid or missing theme colors fall back to the previous header color.
  }
  return { "--forum-preview-header-bg": background, "--forum-preview-header-fg": readableColor(background) };
};
